package ai.flowstorm.studio.resources.space

import ai.flowstorm.studio.App
import ai.flowstorm.studio.common.state.AppState
import ai.flowstorm.common.resources.EntityResource
import ai.flowstorm.studio.model.DialogueSource
import ai.flowstorm.studio.ui.builder.BuildRequest
import io.kvision.rest.HttpMethod
import kotlinx.coroutines.coroutineScope
import kotlinx.coroutines.flow.launchIn
import kotlinx.coroutines.flow.onEach

object BuildRequestResource : EntityResource<BuildRequest>(serializer = BuildRequest.serializer()) {

    init {
        AppState.sub { it.spaceId }.onEach { clear() }.launchIn(App.scope)
    }

    override val resourceUri: String
        get() = "/spaces/${AppState.state.spaceId!!.value}/buildRequests"

    suspend fun reset(entity: BuildRequest, doToast: Boolean = true) = coroutineScope {
        val e = remoteCall<BuildRequest>(createEntityUri(entity) + "/reset", entity, HttpMethod.PUT, doToast = doToast)
        replaceEntity(entity, e)
        e
    }

    suspend fun resetFailed(entity: BuildRequest, doToast: Boolean = true) = coroutineScope {
        val e = remoteCall<BuildRequest>(createEntityUri(entity) + "/resetFailed", entity, HttpMethod.PUT, doToast = doToast)
        replaceEntity(entity, e)
        e
    }

    suspend fun start(entity: BuildRequest, doToast: Boolean = true) = coroutineScope {
        val e = remoteCall<BuildRequest>(createEntityUri(entity) + "/start", entity, HttpMethod.PUT, doToast = doToast)
        replaceEntity(entity, e)
        e
    }

    suspend fun stop(entity: BuildRequest, doToast: Boolean = true) = coroutineScope {
        val e = remoteCall<BuildRequest>(createEntityUri(entity) + "/stop", entity, HttpMethod.PUT, doToast = doToast)
        replaceEntity(entity, e)
        e
    }

    suspend fun getTreeBuildRequest(dialogueSource: DialogueSource) =
        remoteCall<BuildRequest>(resourceUrl + "/dialogueTree/${dialogueSource.id.value}", null, HttpMethod.GET, doToast = false)
}
